import { useEffect, useState } from 'react'
import { resincronizarDesdeCero, sincronizar, suscribirse, type ResumenSync } from '../datos/sync.js'

/**
 * El indicador de conexion, permanente y explicito (§7.1).
 *
 * El offline silencioso genera desconfianza: la recepcionista tiene que saber,
 * sin preguntar, si lo que acaba de escribir ya subio. Por eso muestra tambien
 * cuantas escrituras estan esperando, no solo si hay red.
 */
export function EstadoConexion() {
  const [resumen, setResumen] = useState<ResumenSync | null>(null)
  const [rehaciendo, setRehaciendo] = useState(false)

  useEffect(() => suscribirse(setResumen), [])

  if (!resumen) return null

  const { estado, pendientes, conflictos } = resumen

  const texto =
    estado === 'sin_conexion'
      ? pendientes > 0
        ? `sin conexión · ${pendientes} por subir`
        : 'sin conexión'
      : estado === 'sincronizando'
        ? 'sincronizando…'
        : estado === 'error'
          ? `error de sync${pendientes > 0 ? ` · ${pendientes} en cola` : ''}`
          : pendientes > 0
            ? `${pendientes} por subir`
            : 'al día'

  const color =
    estado === 'sin_conexion'
      ? 'bg-amber-100 text-amber-900'
      : estado === 'error'
        ? 'bg-rose-100 text-rose-900'
        : pendientes > 0
          ? 'bg-sky-100 text-sky-900'
          : 'bg-teal-100 text-teal-900'

  return (
    <div className="flex items-center gap-2">
      {conflictos > 0 && (
        <span className="rounded-full bg-rose-600 px-2 py-0.5 text-xs font-medium text-white">
          {conflictos} conflicto{conflictos > 1 ? 's' : ''}
        </span>
      )}
      <button
        type="button"
        onClick={() => void sincronizar()}
        className={`rounded-full px-3 py-1 text-sm ${color}`}
        title={resumen.error ?? 'Tocar para sincronizar ahora'}
      >
        {texto}
      </button>
      {/* La salida cuando lo local quedo raro y el sync no puede arreglarlo
          solo. No se ofrece siempre: es una operacion cara y ver el boton
          invita a usarlo cuando no hace falta. */}
      {estado === 'error' && (
        <button
          type="button"
          disabled={rehaciendo}
          onClick={() => {
            setRehaciendo(true)
            void resincronizarDesdeCero().finally(() => setRehaciendo(false))
          }}
          className="text-xs text-slate-500 underline decoration-dotted"
          title="Borra lo guardado en este dispositivo y lo baja de nuevo. Lo que esté sin subir se conserva."
        >
          {rehaciendo ? 'rehaciendo…' : 'rehacer datos'}
        </button>
      )}
    </div>
  )
}
